import React from 'react';

const showcaseItems = [
  {
    id: 0,
    title: "资源多",
    subtitle: "1000+ 各行业合作企业",
    description: "合作美的、海尔、海信、老板电器、TCL、奥克斯等。每月新增 50+ 合作企业，源源不断派单。",
    visualColor: "from-blue-600 to-cyan-500",
  },
  {
    id: 1,
    title: "匹配准",
    subtitle: "AI + 人工双重匹配",
    description: "拒绝“无效海投”。系统根据“你的擅长领域 + 过往案例风格”精准推单，大大缩短接单周期。",
    visualColor: "from-purple-600 to-pink-500",
  },
  {
    id: 2,
    title: "服务好",
    subtitle: "保姆式服务支持",
    description: "AI辅助生图/修图，提升效率。每日商单陪跑直播 + 社群答疑，助你快速进阶。",
    visualColor: "from-orange-500 to-amber-500",
  }
];

const OrderSupply: React.FC = () => {
  return (
    <section id="features" className="py-16 md:py-32 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="mb-8 md:mb-16 text-center">
          <h2 className="text-2xl md:text-5xl font-bold text-white mb-2 md:mb-4">3000+ 每月商单量级</h2>
          <p className="text-sm md:text-2xl text-gray-400 max-w-3xl mx-auto font-light">
            几乎人人有单，接单就是如此简单
          </p>
        </div>

        <div className="grid grid-cols-3 gap-2 md:gap-8">
            {showcaseItems.map((item) => (
            <div
                key={item.id}
                className="relative p-3 md:p-8 rounded-xl md:rounded-[2rem] bg-zinc-900/50 border border-white/10 backdrop-blur-xl flex flex-col h-full overflow-hidden"
            >
                <div className={`absolute top-0 right-0 p-16 md:p-32 bg-gradient-to-br ${item.visualColor} blur-[60px] md:blur-[100px] opacity-10 pointer-events-none`} />
                
                <div className="relative z-10 flex flex-col h-full justify-center">
                    <h3 className="text-xs md:text-2xl font-bold text-white mb-1 md:mb-3">{item.title}</h3>
                    <p className="text-[10px] md:text-sm text-gray-300 font-medium mb-2 md:mb-4">{item.subtitle}</p>
                    <p className="text-[8px] md:text-base text-gray-400 leading-relaxed">
                        {item.description}
                    </p>
                </div>
            </div>
            ))}
        </div>

      </div>
    </section>
  );
};

export default OrderSupply;